import Api, { FetchMethodType } from './Api';

export enum PaymentStatus {
  PendingSubmission = 'pending_submission',
  Pending = 'pending',
  Processing = 'processing',
  Sent = 'sent',
  Failed = 'failed',
  Canceled = 'canceled',
  ReversalRequired = 'reversal_required',
  ReversalProcessing = 'reversal_processing',
  Reversed = 'reversed',
  SentViaACH = 'sent_via_ach',
}

export interface PayoffPayment {
  id: string;
  amount: number;
  estimatedCompletionDate?: string;
  firm?: string;
  logoUrl?: string;
}

export interface PayoffPaymentResponse {
  status: PaymentStatus;
  payment: PayoffPayment;
}

export interface GetPayoffPaymentsResponse {
  payments: PayoffPaymentResponse[];
}

export interface PayoffApi {
  getPayoffPayments(applicationId: string): Promise<GetPayoffPaymentsResponse>;
}

export default class PayoffApiService extends Api implements PayoffApi {
  async getPayoffPayments(applicationId: string): Promise<GetPayoffPaymentsResponse> {
    return this.fetch<GetPayoffPaymentsResponse>(`/payoff/${applicationId}/payments`, {
      method: FetchMethodType.GET,
    });
  }
}
